import { FC } from "react"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import { Link } from "react-router-dom"

import NotFoundImage from "~/assets/images/404.svg"

const NotFound: FC = () => {
  return (
    <Stack
      justifyContent='center'
      alignItems='center'
      height='100vh'
      width='100vw'
    >
      <Stack justifyContent='center' alignItems='center' gap={5}>
        <Box component='img' src={NotFoundImage} alt='404' />

        <Typography variant='h4' sx={{ textAlign: "center" }}>
          صفحه ای یافت نشد
        </Typography>

        <Link to='/'>
          <Button size='medium' variant='outlined'>
            بازگشت به صفحه اصلی
          </Button>
        </Link>
      </Stack>
    </Stack>
  )
}

export default NotFound
